import type {AxiosProgressEvent} from "axios";
import router from "@/router";
import {AuthenticationNs} from "@shared/types";
import {useUpgradePopupStore} from "@domains/boards/stores/help.upgrade.store";
import {toast} from '@shared/ms-components'

export enum HTTPErrorEnums {
    HTTP400 = '400',
    HTTP401 = '401',
    HTTP404 = '404',
    HTTP500 = '500',
}

export interface HttpServiceParamsInterface<T> {
    url: string,
    data?: T,
    headers?: any,
    showErrorOnToaster?: boolean,
    /** Bytes on the wire, while they are going. Only multipart upload'lar kullanır. */
    onUploadProgress?: (event: AxiosProgressEvent) => void
}

export const redirectToSignIn = (errorMessage = 'Your session expired. Please sign in'): void => {
    if (errorMessage) {
        toast.error(errorMessage)
    }
    router.push({name: AuthenticationNs.AuthenticationRouteEnums.SignIn})
}

export const catchError = (error: any, showErrorOnToaster: boolean = true): any => {
    if (!error.response) {
        throw error; // Handle or log cases where there's no error response
    }

    const { status, data } = error.response;
    const statusString = status.toString();
    let errMessage = data.message || error.message; // Default to response message, fallback to error message

    if (statusString === HTTPErrorEnums.HTTP401) {
        throw error; // Early return if it's a 401, assuming you don't want to handle it here
    }

    if (statusString === HTTPErrorEnums.HTTP404 && !error.config.url.includes('/token')) {
        router.push({ path: '/dashboard' });
        return;
    }

    if (statusString === HTTPErrorEnums.HTTP500) {
        toast.error(errMessage);
        throw error;
    }

    // Handle specific auth related error descriptions
    if (data.error_description || data.error) {
        const errDesc = data.error_description || data.error;
        switch (errDesc) {
            case 'Bad credentials':
                errMessage = 'Invalid email or password';
                break;
            case 'Invalid refresh token':
            case 'User not found':
                redirectToSignIn();
                return;
            default:
                // If no specific case matched, errMessage will remain as assigned earlier
                break;
        }
    }

    if(data.upgrade) {
        const upgradePopupStore = useUpgradePopupStore();
        upgradePopupStore.openPopup();
    }

    if (showErrorOnToaster) {
        toast.error(errMessage);
    }

    throw error;
};

